import axios from "axios";

export default {
  namespaced: true,

  state: {
    frontEndVersion: process.env.BUILD_NUMBER
      ? `${process.env.VERSION}.${process.env.BUILD_NUMBER}`
      : process.env.VERSION,
    backEndVersion: "",
    loading: false,
    languages: [
      { language: "en", title: "English" },
      { language: "ja", title: "日本語" }
    ],
    modal: false,
    uploadModal: false
  },

  actions: {
    getBackEndVersion: async ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/version`,
          method: "GET"
        })
          .then(res => {
            commit("setBackEndVersion", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    setLoading: async ({ commit }, payload) => {
      commit("updateLoading", payload);
    },
    showModal: async ({ commit }, payload) => {
      commit("updateModal", {
        title: payload.title,
        text: payload.text || ""
      });
    },
    hideModal: async ({ commit }) => {
      commit("updateModal", null);
    },
    changeLanguage: async ({ dispatch }, language) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/user`,
          data: {
            language
          },
          method: "PUT"
        })
          .then(res => {
            if (res.data && res.data.language) {
              resolve(res);
            }
          })
          .catch(err => {
            dispatch(
              "common/showModal",
              {
                title: err.errorCode
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },
    showUploadModal: async ({ commit }) => {
      commit("updateUploadModal", true);
    },
    closeUploadModal: async ({ commit }) => {
      commit("exchange/updateExchangeId", null, { root: true });
      commit("updateUploadModal", false);
    }
  },

  mutations: {
    setBackEndVersion: (state, payload) => {
      if (payload && payload.version) {
        state.backEndVersion = payload.version;
      }
    },
    updateLoading: (state, payload) => {
      state.loading = payload;
    },
    updateModal: (state, payload) => {
      state.modal = payload;
    },
    updateUploadModal: (state, payload) => {
      state.uploadModal = payload;
    }
  }
};
